import { AdminApp } from './admin/AdminApp.js';
import { WorkerApp } from './worker/WorkerApp.js';

/** Same bundle serves both subdomains; the hostname picks the shell. */
export const isAdminHost = window.location.hostname.startsWith('admin.');

export function App() {
  return isAdminHost ? <AdminApp /> : <WorkerApp />;
}
